<template>
 <v-layout row wrap>
     <v-flex xs6 class="pa-1">
          <v-card class="pa-2 card-r grey lighten-4">
            <v-toolbar class="tow-clor-grey card-r shadow-1 pl-3 text-white">
              <div class="text-xs-left f-20 text-capitalize">Past</div>
            </v-toolbar>

           <v-list tow-line class="pa-0 transparent" style="height: 65vh!important; overflow-y: scroll">
             <v-flex v-for="(studentCls, ind) in studentFullClassDetails">
            <div v-if="studentFullClassDetails[ind].class_details.past_modules.length!=0"
            class="text-capitalize f-10 grey--text font-weight-bold">{{studentCls.class_details.name}}</div>
                <template v-for="(item, index) in studentFullClassDetails[ind].class_details.past_modules">
                  <v-subheader class="justify-center"
                               v-if="item.header"
                               :key="item.header"
                  >
                    {{ item.header }}
                  </v-subheader>

                  <v-divider
                    v-else-if="item.divider"
                    :inset="item.inset"
                    :key="index"
                  ></v-divider>

                  <v-list-tile class="shadow-1 card-r white mt-2"
                               v-else
                               :key="item.title"
                               avatar
                               @click=""
                  >
                    <v-list-tile-avatar>
                      <img v-bind:src="item.image">

                      <v-avatar color="blue-grey">
                      <!-- <v-icon dark>account_circle</v-icon> -->
                      </v-avatar>
                    </v-list-tile-avatar> 

                    <v-list-tile-content>
                      <v-list-tile-title class="f-12 font-weight-bold" v-html="item.name"></v-list-tile-title>
                      <v-list-tile-sub-title class="f-12" v-html="item.hours + ' Mins'"> </v-list-tile-sub-title>
                    </v-list-tile-content> 
                    <v-btn
                    <!-- <class="primary no-shadow card-r" small color="blue">Book Now</v-btn> -->
                    <v-list-action>
                      <v-btn class="text-capitalize tow-clor-1 ma-0 text-white"
                             round v-bind:to="'/viewclass/'+item.id" small>view</v-btn>
                    </v-list-action>

                  </v-list-tile>
                </template> 
              </v-flex>
            </v-list>
          </v-card>
        </v-flex> 

        <v-flex xs6 class="pa-1">
          <v-card class="pa-2 card-r grey lighten-4">
            <v-toolbar class="tow-clor-grey card-r shadow-1 pl-3 text-white">
              <div class="text-xs-left f-20 text-capitalize">Completed</div>
            </v-toolbar>

           <v-list tow-line class="pa-0 transparent" style="height: 65vh!important; overflow-y: scroll">
             <v-flex v-for="(studentCls, ind) in studentFullClassDetails">
            <div v-if="studentFullClassDetails[ind].class_details.completed_modules.length!=0"
            class="text-capitalize f-10 grey--text font-weight-bold">{{studentCls.class_details.name}}</div>
                <template v-for="(item, index) in studentFullClassDetails[ind].class_details.completed_modules">
                  <v-subheader class="justify-center"
                               v-if="item.header"
                               :key="item.header"
                  >
                    {{ item.header }}
                  </v-subheader>

                  <v-divider
                    v-else-if="item.divider"
                    :inset="item.inset"
                    :key="index"
                  ></v-divider>

                  <v-list-tile class="shadow-1 card-r white mt-2"
                               v-else
                               :key="item.title"
                               avatar
                               @click=""
                  >
                    <v-list-tile-avatar>
                      <img v-bind:src="item.image">

                      <v-avatar color="blue-grey">
                      <!-- <v-icon dark>account_circle</v-icon> -->
                      </v-avatar>
                    </v-list-tile-avatar> 

                    <v-list-tile-content>
                      <v-list-tile-title class="f-12 font-weight-bold" v-html="item.name"></v-list-tile-title>
                      <v-list-tile-sub-title class="f-12" v-html="item.hours + ' Mins'"> </v-list-tile-sub-title>
                    </v-list-tile-content> 
                    <v-btn
                    <!-- <class="primary no-shadow card-r" small color="blue">Book Now</v-btn> -->
                    <v-list-action>
                      <v-btn class="text-capitalize tow-clor-1 ma-0 text-white"
                             round v-bind:to="'/viewclass/'+item.id" small>view</v-btn>
                    </v-list-action>

                  </v-list-tile>
                </template> 
              </v-flex>
            </v-list>
          </v-card>
        </v-flex> 
     </v-layout>
</template>
<script>
  /* eslint-disable */
  import { mapState } from "vuex";
  export default {
    props:['id'],
    data () {
      return {
        tabs: "booked",
        collectedDate:[],
        enableTimeCount:0,
        loading:false,
        seen: true,
        menu1:false,
        menu2:false,
        menu3:false,
        menu4:false,
        startDate:'',
        endDate:'',
        selectedDate:'',
        selectedTime:'',
        dialog1:false,
        dialog2:false,
        dialog3:false,
        allowedDates:{
          date_from:'',
          date_to:'',
        },
        dark:false,
        arrayEvents:[],
        date_from:'',
        date_to:'',
        timeslot:[],
        teacherTime:'',
        studentId: '',
        packageId:'',
        studentClasses: [],
        UpcomingClass: [],
        pastClasses: [],
        msg:false,
        msgText:'',
        alertType:'',
        selectedModuleId:'',
        selectedPackageId:'',
        dialog2Data:'',
        dialog3Data:'',
        AlertMsg:''
      }
    },
    watch:{
     
    },
    beforeCreate(){
     
    },
    updated:function(){
       
    },
    created() {
    },
    methods:{
      
    },

    computed: {
      ...mapState({
        classDetails: "classDetails",
        studentFullClassDetails:"studentFullClassDetails"
      })
    },
  }
</script>
<style>
  .v-btn--small{
    width: 104px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/profile/student/PastClasses.vue